import { DataTable, FormLabel, Heading, Loader, Select } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useOwnershipChangePacket from "./useOwnershipChangePacket";

const OwnershipChangePacket = () => {
  const {
    columns,
    globalFilter,
    setGlobalFilter,
    ownershipChangePacketData,
    onCreateNew,
    communityList,
    communityKey,
    onCommunityChange,
    isCommunityLoading,
    isOwnershipChangePacketLoading,
    communityData,
    onRowClick
  } = useOwnershipChangePacket();

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6 flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <Heading
          title="Ownership Change Packet"
        />
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
          <div className="relative">
            <FormLabel>Select Community</FormLabel>
            <Select
              key={communityKey}
              placeholder={""}
              searchPlaceholder={"Search..."}
              noDataPlaceholder={"Community No Found"}
              options={communityList?.map((data: any) => ({
                value: data?.communityId?.toString(),
                label: data?.name,
              }))}
              value={communityData?.communityId?.toString()}
              onChange={onCommunityChange}
              className="h-[36px] w-[200px]"
              disabled={isCommunityLoading}
            />
          </div>
          <div className="relative">
            <Input
              type="text"
              placeholder="Search"
              value={globalFilter ?? ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              className="w-full sm:w-72 bg-white h-[40px]"
              startIcon={<Search className="w-4 h-4" />}
            />
          </div>
          <Button className="h-9 whitespace-nowrap" onClick={onCreateNew}>
            + Create New
          </Button>
        </div>
      </div>

      {isOwnershipChangePacketLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={(ownershipChangePacketData || [])?.sort(
            (a: any, b: any) =>
              new Date(b.updatedAt).getTime() -
              new Date(a.updatedAt).getTime()
          )}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
          className="shadow-sm"
          onRowClick={onRowClick}
        />
      )}
    </div>
  );
};

export default OwnershipChangePacket;
